module.exports = __webpack_public_path__ + "static/media/magic8Ball.0df9875e.png";